export default {
  // ========== Status tooltips ==========
  outOfSpecTooltip: 'This session is outside the pedagogical hours configured for the subject.',
  completedTooltip: 'Completed',

  // ========== Table labels/texts ==========
  supportResources: 'Support Resources',

  // ========== Clear row ==========
  clearRow: 'Clear row',
  clearRowConfirmTitle: 'Clear session {order}?',
  clearRowConfirmText:
    'All selections in the row will be removed, including the associated evaluation. This action cannot be undone.',

  // ========== Modals ==========
  sessionObservationsModalTitle: 'Observations for session {order}',
  selectEntity: 'Select {entity}',
  contentsDefinedByEntity: 'The {criteria} are defined by {raMicro}',
  removeSelection: '-- Remove Selection --',
  contentsInEntity: 'Contents in {entity}:',
  contentsOfEntity: 'Contents of the {entity}:',
  basicBibliography: 'Basic Bibliography',
  feedback: 'Feedback',
  directTeachingActivities: 'Direct Teaching Activities',
  minimumStrategiesShown: 'Shown in',
  coloredWord: 'color',
  minimumStrategiesDescription: 'are the {strategies} defined as minimum for the {matter}.',
  minimumStrategiesOfEntity: 'Minimum Strategies of the {entity}',

  // ========== Session validations ==========
  selectOneError: 'Select a {entity}.',
  selectAtLeastOneContent: 'Select at least one Content.',
  selectSomeError: 'Select some {entity}.',
  selectDirectTeachingActivityError: 'Select some direct teaching activity.',
};
